import type { ReactionStats } from './types'

export function isPostPublished(publishTime: string | null) {
    if (!publishTime) {
        return false
    }

    return Date.parse(publishTime) < Date.now()
}

export function isReactionKey(key: any, obj: ReactionStats): key is keyof ReactionStats {
    return key in obj
}

export function fillReactionStats(
    data: { [index: string]: { postID: string; emoji: string; count: number }[] },
    ids: string[]
): Record<string, ReactionStats> {
    const output: Record<string, ReactionStats> = {}

    for (const id of ids) {
        const stats: ReactionStats = {
            thumbs_up: 0,
            party_popper: 0,
            sparkling_heart: 0,
            face_with_open_mouth: 0,
            grinning_squinting_face: 0,
        }

        const reactions = data[id]

        if (!reactions) {
            output[id] = stats
            continue
        }

        for (const { emoji, count } of reactions) {
            if (isReactionKey(emoji, stats)) {
                stats[emoji] = count
            }
        }

        output[id] = stats
    }

    return output
}
